import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Aboutbox = () => {
  return (
    <>
      <section className='about-box'>
        <Container>
          <Row>
            <Col md={12}>
              <div className="boxwrap">
                <div className="cont">
                  <h3 className='text-gradient'>Join Us Today and Experience the Difference With Myfx.ca.</h3>
                </div>
                <div className="btn-group gap-3">
                  <Link to="/contact" className='button blue'>Contact Us</Link>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}

export default Aboutbox